/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum ContactDisplayRole {
  None = "None",
  Owner = "Owner",
}

export const ContactDisplayRoleDisplay: Record<ContactDisplayRole, string> = {
  [ContactDisplayRole.None]: "None",
  [ContactDisplayRole.Owner]: "Owner",
};
